import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CITIES } from "@/lib/api";
import { AvailabilityForm, Packages, CtaStrip, GoogleReviews } from "@/components/sections/HomeSections";
import SEO, { localBusinessSchema } from "@/components/SEO";

export default function CityPage() {
  const { slug } = useParams();
  const city = CITIES.find(c => c.slug === slug);
  if (!city) return <div className="pt-40 text-center">City not found.</div>;
  const heroImg = `https://images.unsplash.com/photo-1606800052052-a08af7148866?auto=format&fit=crop&w=1800&q=80`;
  return (
    <div data-testid="city-page" className="pt-24">
      <SEO
        title={`Wedding Photographer in ${city.name}`}
        description={`A small wedding photography and film team based in Toronto, telling honest love stories in ${city.name} and across ${city.country}. Calm presence, careful editing, memories made to last.`}
        path={`/wedding-photographer/${city.slug}`}
        image={heroImg}
        jsonLd={localBusinessSchema()}
      />
      <section className="relative h-[70vh] overflow-hidden">
        <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 cine-overlay" />
        <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-16">
          <div className="eyebrow">{city.country}</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light mt-3 tracking-tight">
            Wedding Photographer<br/>in <em className="text-[#D4AF37] not-italic">{city.name}</em>
          </h1>
          <p className="text-white/70 max-w-2xl mt-4">
            A small team telling honest love stories in {city.name} and across {city.country} —
            quiet presence, careful frames, films that bring you back to your day.
          </p>
          <Link to="/contact#availability" className="btn-gold mt-8 self-start">Check {city.name} Availability <ArrowRight size={14}/></Link>
        </div>
      </section>

      <section className="section-pad max-w-[1400px] mx-auto grid lg:grid-cols-2 gap-12">
        <div>
          <div className="eyebrow">Couples in {city.name}</div>
          <h2 className="font-serif text-4xl mt-3">Honest. Cinematic. <em className="text-[#D4AF37] not-italic">Heartfelt.</em></h2>
          <p className="text-white/70 mt-5 leading-relaxed">
            From small downtown ceremonies to large family celebrations, we've been honored to stand
            beside couples across {city.name}. Our work focuses on the emotions, traditions and
            in-between moments that make your wedding feel like yours — and yours alone.
          </p>
        </div>
        <ul className="grid sm:grid-cols-2 gap-3">
          {[
            `${city.name} Wedding Photographer`,
            `${city.name} Wedding Videographer`,
            "Honest, Editorial Style",
            "Films That Bring You Back",
            "Drone & Aerial Moments",
            "Engagement Sessions",
            "Same-Day Social Reels",
            "Destination Weddings",
          ].map(x => (
            <li key={x} className="border border-white/10 p-4 text-sm text-white/85 bg-[#0a0a0a]">{x}</li>
          ))}
        </ul>
      </section>

      <Packages />
      <GoogleReviews />
      <AvailabilityForm />
      <CtaStrip />
    </div>
  );
}
